import { Injectable } from '@angular/core';
import { ViewStore } from '@coach-bot/data-access/shared';
import { AuthState } from '@coach-bot/features/auth';
import { TranslateService } from '@ngx-translate/core';
import { ExtensionCommunicationService } from '@shared/extension';
import { Language, LanguageData, getLanguageData } from '@shared/translate';
import { ONE_SECOND_MS } from '@shared/utils';
import { Subscription, interval } from 'rxjs';

const UPDATE_IS_EXTENSION_POPUP_OPENED_INTERVAL_MS: number = ONE_SECOND_MS * 6;

@Injectable()
export class AppSubscriptionsService {
  private currentLanguageSubscription: Subscription | null = null;
  private unathrorizedErrorSubscription: Subscription | null = null;
  private updateIsExtensionPopupOpenedSubscription: Subscription | null = null;

  private isSubscribed: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private authState: AuthState,
    private extensionCommunicationService: ExtensionCommunicationService,
    private translateService: TranslateService,
    private viewStore: ViewStore
  ) {}

  subscribe() {
    if (this.isSubscribed) {
      return;
    }

    this.unathrorizedErrorSubscription = this.extensionCommunicationService.unathrorizedError$.subscribe(() => {
      this.authState.handleUnauthorizedError();
    });

    this.currentLanguageSubscription = this.viewStore.currentLanguage$.subscribe((currentLanguage: Language) => {
      const languageData: LanguageData | null = getLanguageData(currentLanguage);
      if (languageData) {
        this.viewStore.setCurrencySign(languageData.currencySign);
      }
      this.translateService.use(currentLanguage);
    });

    this.updateIsExtensionPopupOpenedSubscription = interval(UPDATE_IS_EXTENSION_POPUP_OPENED_INTERVAL_MS).subscribe(
      () => {
        this.extensionCommunicationService.updateIsExtensionPopupOpened(true);
      }
    );

    this.subscriptions = [
      this.currentLanguageSubscription,
      this.unathrorizedErrorSubscription,
      this.updateIsExtensionPopupOpenedSubscription,
    ];

    this.isSubscribed = true;
  }

  unsubscribe() {
    if (!this.isSubscribed) {
      return;
    }
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });

    this.isSubscribed = false;
  }
}
